export enum MODAL {
  CLOSE_BTN = "modalCloseBtn",
  FOOTER_CANCEL_BTN = "modalFooterCancelBtn",
  FOOTER_CONFIRM_BTN = "modalFooterConfirmBtn",
  BACKGROUND = "modalBackground",
  COMMENT = "modalComment",
}
